<div style="height: 350px; overflow: hidden;">
  <app-loading-animation 
    [isRouting]="isLoading" 
    [margin]="'50px auto'"
    [width]="80"
    [height]="15"
    [background]="'none'"
  >
    <div class="tab-pane" role="tabpanel" id="complete">
      <div class="step44">
        <div class="spacer30"></div>
        <div class="transactionSummary">
          <div *ngIf="transaction3dsResult">
            <div class="divCircle okeyColor">
              <i class="icon icon-check"></i>
            </div>
            <h2
              class="text-center okeyColorText"
              [innerHTML]="
                'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_SUCCESSFULL_LABEL'
                  | translate
              "
            ></h2>
            <table>
              <tr>
                <td
                  class="tableHeads"
                  [innerHTML]="
                    'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_REFERENCE_CODE_LABEL'
                      | translate
                  "
                ></td>
                <td>{{ viewModel.getRefCode() }}</td>
              </tr>
              <tr>
                <td
                  class="tableHeads"
                  [innerHTML]="
                    'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_AMOUNT_LABEL'
                      | translate
                  "
                ></td>
                <td>
                  {{ viewModel.getAmount() }}
                  {{ viewModel.getCurrency() }}
                </td>
              </tr>
              <tr>
                <td
                  class="tableHeads"
                  [innerHTML]="
                    'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_DATE_LABEL'
                      | translate
                  "
                ></td>
                <td>{{ viewModel.getDateTime() }}</td>
              </tr>
            </table>
          </div>
          <div *ngIf="!transaction3dsResult">
            <div class="divCircle notOkeyColor">
              <i
                class="icon icon-close"
                style="
                  font-size: 40px;
                  vertical-align: middle;
                  position: relative;
                  top: -10px;
                "
              ></i>
            </div>
            <h2
              class="text-center notOkeyColorText"
              [innerHTML]="
                'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_FAIL_LABEL'
                  | translate
              "
            ></h2>
            <table>
              <tr *ngIf="viewModel.getMessage()">
                <td
                  class="tableHeads"
                  [innerHTML]="
                    'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_RESULT_MESSAGE_LABEL'
                      | translate
                  "
                ></td>
                <td>{{ viewModel.getMessage() }}</td>
              </tr>
              <tr>
                <td
                  class="tableHeads"
                  [innerHTML]="
                    'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_REFERENCE_CODE_LABEL'
                      | translate
                  "
                ></td>
                <td>{{ viewModel.getRefCode() }}</td>
              </tr>
              <tr *ngIf="viewModel.getDateTime()">
                <td
                  class="tableHeads"
                  [innerHTML]="
                    'CARDOPERATIONS_ONLINE_CHARGE_COMPLETE_DATE_LABEL'
                      | translate
                  "
                ></td>
                <td>{{ viewModel.getDateTime() }}</td>
              </tr>
            </table>
          </div>
          <div class="spacer30"></div>
        </div>
      </div>
    </div>
  </app-loading-animation>
</div>